<template>
	<div>
		<input
			:id="name"
			:name="name"
			type="checkbox"
			@change="handleField($event.target.checked)"
		/>
	</div>
</template>

<script>
import { mutations } from "../store";

export default {
	methods: {
		handleField(checked) {
			if (checked) {
				this.setLandscapePremium(this.data.value);
			} else {
				this.setLandscapePremium(0);
			}
		},
		setLandscapePremium: mutations.setLandscapePremium
	},

	props: {
		data: {
			type: Object,
			required: true
		},

		name: {
			type: String,
			required: true
		}
	}
};
</script>
